import { Link } from "react-router-dom";
import { COMPANY, IMAGES } from "../data/site";
import { WhatsAppFloat } from "./WhatsAppFloat";

export const Footer = () => (
  <>
  <footer className="border-t border-zinc-800" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12">
      <div className="flex items-end gap-6">
        <img src="/logo-mark.png" alt="Omkaar Metals Ltd emblem" className="h-20 w-20 object-contain lg:h-28 lg:w-28" data-testid="footer-logo" />
        <p className="font-display text-[13vw] font-semibold uppercase leading-none tracking-tight text-zinc-800/80 select-none lg:text-[9rem]" aria-hidden="true">
          Omkaar
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-3">
        <div>
          <p className="font-mono-label text-[10px] text-copper">Contact</p>
          <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="mt-4 block font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">
            {COMPANY.email}
          </a>
          <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="mt-2 flex items-center gap-3 font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">
            <img src="https://flagcdn.com/w40/zm.png" alt="Zambia flag" className="h-4 w-6 object-cover" />
            {COMPANY.phone} — Zambia
          </a>
          <a href={COMPANY.whatsapp2} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-2" className="mt-2 flex items-center gap-3 font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">
            <img src="https://flagcdn.com/w40/in.png" alt="India flag" className="h-4 w-6 object-cover" />
            {COMPANY.phone2} — India
          </a>
          <p className="mt-2 font-mono text-sm text-zinc-500">{COMPANY.location}</p>
          <div className="barcode mt-5 w-44" aria-hidden="true" />
        </div>

        <div>
          <p className="font-mono-label text-[10px] text-copper">Navigate</p>
          <div className="mt-4 flex flex-col gap-2">
            <a href="/#products" data-testid="footer-link-products" className="font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">Products</a>
            <a href="/#about" data-testid="footer-link-about" className="font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">About</a>
            <Link to="/founders" data-testid="footer-link-founders" className="font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">Founders</Link>
            <a href="/#contact" data-testid="footer-link-contact" className="font-mono text-sm text-zinc-300 transition-colors duration-300 hover:text-copper-light">Contact</a>
          </div>
        </div>

        <div data-testid="footer-president-block">
          <p className="font-mono-label text-[10px] text-copper">With respect to the Republic of Zambia</p>
          <div className="mt-4 flex items-center gap-4">
            <div className="h-24 w-20 shrink-0 overflow-hidden border border-zinc-700">
              <img
                src={IMAGES.president}
                alt="His Excellency Hakainde Hichilema, President of the Republic of Zambia"
                className="h-full w-full object-cover object-top"
                data-testid="footer-president-portrait"
              />
            </div>
            <div>
              <p className="font-display text-sm font-medium uppercase text-zinc-200">H.E. Hakainde Hichilema</p>
              <p className="mt-1 text-xs text-zinc-500">President of the Republic of Zambia</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-20 flex flex-col gap-3 border-t border-zinc-800 pt-8 md:flex-row md:items-center md:justify-between">
        <p className="font-mono text-xs text-zinc-500" data-testid="footer-company-number">
          {COMPANY.name} · Company No. {COMPANY.number} · {COMPANY.location}
        </p>
        <p className="font-mono text-[10px] text-zinc-600">
          Presidential photo: Quirinale.it, via Wikimedia Commons · © {new Date().getFullYear()} {COMPANY.name}
        </p>
      </div>
    </div>
  </footer>
  <WhatsAppFloat />
  </>
);
